import { Route, UpsertRoute } from '@/models/route.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedRoutes = async (input: PaginationFilterRequest): Promise<PagedResponseModel<Route>> => {
  return await getReq(createUrl("a/Route/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRoutesLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedRoutes(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getRoute = async (id: number): Promise<BaseResponseModel<Route>> => {
  return await getReq(createUrl(`a/Route/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRoute = async (input: UpsertRoute): Promise<BaseResponseModel<Route>> => {
  return await postReq(createUrl("a/Route/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const ExchangeLatLng = async (id: number): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/Route/ExchangeLatLng/" + id)
  ).then((res: any) => res.data);
};
